import { isNumber, isString } from "../utils/schemaUtils";

export interface LinearIssue {
  id: string;
  identifier: string;
  title: string;
  state: string;
  // Linear's state category: triage, backlog, unstarted, started, completed,
  // canceled. Left as a string so a category a newer Linear adds still renders.
  stateType: string;
  // 0 means "no priority"; 1 is Urgent through 4 Low.
  priority: number;
  assignee?: string;
  team: string;
  project?: string;
  labels: string[];
  url: string;
  updatedAt: string;
}

export const isLinearIssue = (v: unknown): v is LinearIssue => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.id) &&
    isString(r.identifier) &&
    isString(r.title) &&
    isString(r.state) &&
    isString(r.stateType) &&
    isNumber(r.priority) &&
    (r.assignee === undefined || isString(r.assignee)) &&
    isString(r.team) &&
    (r.project === undefined || isString(r.project)) &&
    Array.isArray(r.labels) &&
    r.labels.every(isString) &&
    isString(r.url) &&
    isString(r.updatedAt)
  );
};

export interface LinearIssuesPayload {
  type: "linear_issues";
  issues: LinearIssue[];
  hasMore: boolean;
  query?: string;
}

export const parseLinearIssuesPayload = (v: unknown): LinearIssuesPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_issues") return null;
  if (!Array.isArray(r.issues) || !r.issues.every(isLinearIssue)) return null;
  if (typeof r.hasMore !== "boolean") return null;
  if (r.query !== undefined && !isString(r.query)) return null;
  return {
    type: "linear_issues",
    issues: r.issues,
    hasMore: r.hasMore,
    query: r.query,
  };
};
